import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private api: ApiService) { }

  createEmailConfig(data:any): Observable<any> {
    return this.api.post(environment.createEmailConfig,data);
  }
  getEmailConfig(data:any): Observable<any> {
    return this.api.post(environment.getEmailConfig,data);
  }

  getEmailConfigById(data:any): Observable<any> {
    return this.api.post(environment.getEmailConfigById,data);
  }

  updateEmailConfig(data:any): Observable<any> {
    return this.api.post(environment.updateEmailConfig,data);
  }



  
  
  
  
  
}


